<div class="profile-settings-block">

    <div class="profile-settings-block-inner">

        <div class="profile-settings-block-info">

            @for (fieldTitle of fieldGroup?.fieldTitles; track $index) {
            <div class="profile-settings-block-info-item"
                [class.profile-settings-block-info-item--icon]="fieldTitle.icon != null">

                @if (fieldTitle.icon != null) {
                <rpc-icon class="profile-settings-block-info-item-icon" [class]="fieldTitle.iconClass"
                    [iconName]="fieldTitle.icon">
                </rpc-icon>
                }

                <div class="profile-settings-block-info-item-text">
                    {{fieldTitle.title | translate}}:
                </div>

            </div>
            }

        </div>

        @for (segment of fieldGroup?.segments; track $index) {
        <div class="profile-settings-block-section">

            <rpc-slide-toggle class="profile-settings-block-section-toggle" [togglePosition]="'right'"
                [firstText]="segment.toggleField.title" [checked]="segment.toggleField.value"
                [form]="segment.toggleField.formGroup" [controlName]="segment.toggleField.controlName"
                [canToggle]="segment.toggleField.isAvailable || !!segment.toggleField.formGroup.value[segment.toggleField.controlName]"
                (changed)="onSettingChanged(segment.toggleField.key, $event.checked, segment.notificationType)"
                (changesCanceled)="showSmsError()">
            </rpc-slide-toggle>

            <div class="profile-settings-block-section-item-wrap"
                [class.profile-settings-block-section-item-wrap--active]="!!segment.toggleField.formGroup.value[segment.toggleField.controlName]">

                @for (field of segment.fields; track $index) {
                <div class="profile-settings-block-section-item">

                    <div class="profile-settings-block-section-item-label" [title]="field.title | translate"
                        [class.profile-settings-block-section-item-label--icon]="field.icon != null">

                        @if (field.icon != null) {
                        <rpc-icon class="profile-settings-block-section-item-label-icon" [class]="field.iconClass"
                            [iconName]="field.icon">
                        </rpc-icon>
                        }

                        <div class="profile-settings-block-section-item-label-text">
                            {{field.title | translate}}:
                        </div>

                    </div>

                    <rpc-select class="profile-settings-block-section-item-select" [appearance]="'fill'"
                        [controlOptions]="field.controlOptions"
                        [disabled]="!segment.toggleField.formGroup.value[segment.toggleField.controlName]"
                        (changed)="onSettingChanged(field.key, $event.value, segment.notificationType)">
                    </rpc-select>

                </div>
                }

            </div>

        </div>
        }

    </div>

</div>